import { ca } from '@cian/analytics';
import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { offerDataSelector, selectOffer } from '../../selectors';

export const BookButtonContainer: React.FC = () => {
  const offerData = useSelector(offerDataSelector);
  const offer = useSelector(selectOffer);

  const { trackingUrl } = offerData;
  const { id, offerType, externalOfferUrl } = offer;

  const onClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Phones',
      action: 'Open_card_dailyrent',
      label: trackingUrl,
      page: {
        pageType: 'Card',
        siteType: 'desktop',
      },
      products: [{ id, offerType }],
    });
  };

  return (
    <div>
      <LinkButton
        theme="fill_primary"
        size="M"
        fullWidth
        target="_blank"
        rel="noopener noreferrer"
        href={externalOfferUrl}
        onClick={onClick}
      >
        Проверить места
      </LinkButton>
    </div>
  );
};
